module.exports = __webpack_public_path__ + "static/media/lefthandmob.2bd33ede.png";